import StandardsList from './StandardsList';

export default StandardsList;
